import React from 'react';

import * as cr from './_cr';
import * as hf from './_hf';
import * as ht from './_ht';
import * as f from './_cmFTH';
import * as ls from "./_csLcl"; // local state

import * as icm from './icm';

//import * as icvI20K10To from './icvI20K10To';
//import * as icvI20K10Co from './icvI20K10Co';

import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as IptC from "./_ccbIptC";
import * as SrlC from "./_ccbSrlC";
import * as LblC from "./_cccLblC";
import * as BtnCttC from './_ccmBtnCttC';
import * as TblC from "./_ccmTblC";

import * as icvBaseK10Rz from './icvBaseK10Rz';
import * as icvI20___Ci from "./icvI20___Ci";
import * as icvI20___Mz from './icvI20___Mz';

import * as ica from 'src/ica';

import { a } from "./_csAbt";

let $i20z = icvI20___Mz.itlI20z();

export const N = (pz: {
}) => {

  const _sPz = ls.usePagez({
    steps: [1], // ドメイン共通のため
    phs: 'dpy',
    lblz: icm.grtLblz({
      tgt: 'メールサーバ',
    })
  });

  icm.loadAtTopAsync({
    _31r_fst: 0,
    frcUdt: _sPz.udt,
  });

  return (
    cr.c(icvBaseK10Rz.N, {
      key: -10,
      cz: {
        pageName: 
          _sPz.crt.steps[0] == 1 ?
            _sPz.crt.lblz.ttlz.ctt
          : ''
      },
      oClds: [

        _sPz.crt.steps[0] == 1 ?
        cr.c(BoxC.N, {
          key: -20,
          abtType: 'bdyCmnz',
          oClds: [

            cr.c(GridC.N, {
              key: -10,
              abtType: 'barFtnOrnz',
              boxStlz: a(`mb/2`),
              lineCs: [{
                cellCs: [
                  {
                    oClds: [
                    ]
                  },
                  {
                    oClds: [
/*
                      cr.c(LblC.N, {
                        key: -10,
                        abtType: 'ftnCmnz',
                        boxStlz: a('dw/23'),
                        lblCz: {
                          boxStlz: a('dw/8'),
                          textz: {
                            pfx: '変更履歴',
                          }
                        },
                        cttCz: {
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              abtType: 'ftnCmnz',
                              cz: {
                                bEdit: true,
                                iptType: 'pcr',
                                ls: [],
                              },
                            })
                          ]
                        },
                      })
*/
                    ]
                  }
                ]
              }]
            }),

            cr.c(BoxC.N, {
              key: -20,
              abtType: 'cttCmnz',
              oClds: [

                cr.c(SrlC.V, {
                  key: -10,
                  srlStlz: {
                    otrz: a('dw/f dwx/120 f/1'),
                  },
                  oClds: [

                    cr.c(icvI20___Ci.D, {
                      key: -10,
                      sPz: _sPz,
                      cz: {
                        ccd: 'rd'
                      }
                    }),

                  ],
                }),

                cr.c(icvI20___Ci.B, {
                  key: -20,
                  sPz: _sPz,
                  cz: {
                    lblz: _sPz.crt.lblz,
                    sc: 'rd7',
                  },
                }),

              ]
            })

          ]
        })

        : null,

      ]
    })
  );
};
